



























import InputField from '@components/common/input-field.vue';
import { MAX_AMOUNT_TOP_UP, MIN_AMOUNT_TOP_UP } from '@constants';
import Vue from 'vue';

export default Vue.extend({
	name: 'AmountTopUp',
	components: {
		InputField,
	},
	data() {
		return {
			amount: '',
			step: 2,
			plus: '+',
			minus: '-',
		};
	},
	computed: {
		value(): number {
			return +this.amount;
		},
		isMinAmount(): boolean {
			return this.value <= MIN_AMOUNT_TOP_UP;
		},
		isMaxAmount(): boolean {
			return this.value >= MAX_AMOUNT_TOP_UP;
		},
	},
	methods: {
		add(): void {
			if (this.value < MAX_AMOUNT_TOP_UP)
				this.amount = String(this.value + this.step);

			if (this.value > MAX_AMOUNT_TOP_UP)
				this.amount = String(MAX_AMOUNT_TOP_UP);
		},
		subtract(): void {
			if (this.value > MIN_AMOUNT_TOP_UP)
				this.amount = String(this.value - this.step);
		},
	},
});
